import * as React from 'react';
import { Modal } from 'react-bootstrap';

interface IImageModalProps {
    shouldShowImageModal: boolean;
    imageReference: string;
    closeImageModal: () => void;
}

const ImageModal = (props: IImageModalProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <div>
            <Modal bsSize="large" show={props.shouldShowImageModal} onHide={props.closeImageModal}>
                <Modal.Body>
                    <img
                        className="responsive-image-down"
                        src={`${apiUrl}/file/${props.imageReference}`}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ImageModal;
